import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { Ref } from 'vue'

export const useActivityStore = defineStore('activity', () => {
  const activityPromptTime: number = 60000
  const lastActivity: Ref<number> = ref(Date.now())

  function initiate() {
    document.addEventListener('click', updateActivity)
    updateActivity()
  }

  function stop() {
    document.removeEventListener('click', updateActivity)
    updateActivity()
  }

  function screenClickNeeded() {
    return Date.now() - lastActivity.value >= activityPromptTime
  }

  function updateActivity() {
    lastActivity.value = Date.now()
  }

  return { screenClickNeeded, initiate, stop, updateActivity }
})
